import theme from '@/config/theme';
import styled from 'vue-styled-components';

export const GixModal = styled.div`
  .links-store {
    display: flex;
    justify-content: space-around;
  }
  .area-store {
    display: flex;
    flex-direction: column;
  }
  .qr-code {
    width: 114px;
    height: auto;
  }
`;

export const CardInfoContentRow = styled.div`
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: row;
  .btn-action {
    min-width: 190px;
    display: flex;
    margin-left: ${theme.spacings.large};
    flex-direction: column;
    align-content: flex-end;
    button {
      margin-bottom: 5px;
    }
    p {
      font-size: 13px;
      text-align: justify;
    }
  }
`;

export const CardInfoContentCol = styled.div`
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: row;
`;

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  gap: 62px;
  padding-top: 140px;
`;

export const Main = styled.main`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;
  padding: ${theme.spacings.xxlarge} ${theme.spacings.xxxlarge};

  @media screen and (min-width: ${theme.grid.xltablet.breakpoint}) {
    grid-template-columns: repeat(2, 1fr);
    gap: 60px;
  }

  > div {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 16px;

    > .block {
      display: flex;

      &.column {
        flex-direction: column;
        gap: ${theme.spacings.medium};
      }

      p {
        font-size: ${theme.font.sizes.p2};
        line-height: ${theme.font.lineHeights.p2};
      }

      p.label {
        color: ${theme.colors.gray5};
        display: flex;
      }

      p.value {
        color: ${theme.colors.gray6};
        margin-left: ${theme.spacings.xxsmall};
      }
    }
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  .alert, .error {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.2rem;
    color: ${theme.colors.supportAlert};
    margin-bottom: 0.5rem;

    svg {
      width: 2.5rem;
      height: 2.5rem;
    }
  }
  .accordionContainer {
    padding: 1rem 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .accordionItem {
      position: relative;
      display: flex;
      width: 100%;

      p {
        flex-basis: 100%;
        color: ${theme.colors.gray6};
        font-size: 0.9rem;
        align-self: center;
        font-weight: 400;

        display: block;
        max-width: 75%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        svg {
          width: 15px;
          height: 15px;
          color: ${theme.colors.primaryBlue};

          :hover {
            transform: scale(1.1);
          }
        }
      }

      ::before {
        position: absolute;
        display: inline-block;
        content: "";
        border-top: 1px solid ${theme.colors.gray2};
        width: 100%;
        left: 0;
        transform: translateY(-1rem);
      }

      &:first-child {
        margin-top: 0.5rem;
        background-color: ${theme.colors.grayBg};
      }

      &:first-child::before {
        content: none;
      }

      &.spaceBetween {
        justify-content: space-between;

        p {
          flex-basis: auto;
        }
      }
    }
  }
`;

export const ModalUploadDocument = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-bottom: ${theme.spacings.small};

  .select{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 80%;
  }

  label {
    margin-bottom: ${theme.spacings.xsmall};
  }
  p.title {
    font-family: Nunito,sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
    text-align: center;
    color: #193280;
    margin-bottom: ${theme.spacings.xxlarge};
  }
  .box-upload{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border: 1px dashed #D6D6D6;
    border-radius: 16px;
    width: 100%;
    background-color: #FCFCFC;
    padding: 3% 0;
    margin-bottom: ${theme.spacings.xxlarge};
    cursor: pointer;
  }

  .box-upload2{
    width: 79%;
  }

  .box-upload3{
    width: 100%;
  }

  .box-upload svg{
    width: 90px;
    height: 90px;
  }

  .box-upload .title-import{
    font-size: 14px;
    color: ${theme.colors.primaryBlue};
    font-weight: 700;
    padding-top: 10px;
  }

  .box-upload .sub-title{
    padding-top: 10px;
    font-size: 14px;
    color: #161617;
  }

  .box-upload .sub-title .name{
    color: ${theme.colors.primaryBlue};
    font-weight: 700;
    color: #161617;
  }
  .documents {
      width: 100%;
      padding: 10px;
      border: solid 1px ${theme.colors.gray3};
      border-radius: 8px;
      display: flex;
      align-content: center;
      align-items: center;
      justify-content: space-between;
  }
  .documents > span {
    font-weight: 700;
    color: ${theme.colors.blackNeutral};
  }
  .documents > .remove {
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
  }
`;
